<main class="page">
    <section class="card">

        <app-header />
        <router-outlet></router-outlet>
    </section>
</main>
